import {updateAllColorWarnings} from '../shared_functions/color_functions'
document.addEventListener('turbolinks:load', () => {

    // background color
    const byodAppBackgroundColorTextField = document.getElementById('byodAppBackgroundColorTextField')
    const byodAppBackgroundColorColorField = document.getElementById('byodAppBackgroundColorColorField')
    const colorPreviewBackground = document.getElementById('byodAppBackgroundColorPreview')
    const noValidColorMessageBackground = document.getElementById('noValidColorMessageBackground')
    // background image
    const backgroundImg = document.getElementById('byodAppBackgroundImg')
    // Ui color
    const byodAppUiColorTextField = document.getElementById('byodAppUiColorTextField')
    const byodAppUiColorColorField = document.getElementById('byodAppUiColorColorField')
    const colorPreviewUi = document.getElementById('byodAppUiColorPreview')
    const noValidColorMessageUi = document.getElementById('noValidColorMessageUi')

    // background color
    const byodWelcomeScreenBackgroundColorTextField = document.getElementById('byodWelcomeScreenBackgroundColorTextField')
    const byodWelcomeScreenBackgroundColorColorField = document.getElementById('byodWelcomeScreenBackgroundColorColorField')
    const byodWelcomeScreenBackgroundColorPreview = document.getElementById('byodWelcomeScreenBackgroundColorPreview')
    const noValidColorMessageWelcomeScreenBackground = document.getElementById('noValidColorMessageWelcomeScreenBackground')
    // background image
    const byodWelcomeScreenBackgroundImg = document.getElementById('byodWelcomeScreenBackgroundImg')
    // Ui color
    const byodWelcomeScreenUiColorTextField = document.getElementById('byodWelcomeScreenUiColorTextField')
    const byodWelcomeScreenUiColorColorField = document.getElementById('byodWelcomeScreenUiColorColorField')
    const byodWelcomeScreenUiColorPreview = document.getElementById('byodWelcomeScreenUiColorPreview')
    const noValidColorMessageWelcomeScreenUi = document.getElementById('noValidColorMessageWelcomeScreenUi')


    // Background color
    if (byodAppBackgroundColorTextField !== null && byodAppBackgroundColorColorField !== null &&
        colorPreviewBackground !== null && noValidColorMessageBackground !== null) {

        // show/hide invalid color warning on page load
        if (isColor(byodAppBackgroundColorTextField.value)) {
            noValidColorMessageBackground.classList.add('hidden')
        } else {
            noValidColorMessageBackground.classList.remove('hidden')
        }
        if (backgroundImg === null){
            updateAllColorWarnings("byodAppBackgroundColor", null)
        }

        // change listener for background color: show/hide invalid color warning, show preview color
        byodAppBackgroundColorTextField.addEventListener("change", function(e) {
            if(isColor(this.value)) {
                colorPreviewBackground.style.fill = this.value // shoe preview color
                noValidColorMessageBackground.classList.add('hidden')
                updateAllColorWarnings("byodAppBackgroundColor", null)
            } else {
                colorPreviewBackground.style.fill = null
                noValidColorMessageBackground.classList.remove('hidden')
            }

            updateColorValue("byodAppBackgroundColor", byodAppBackgroundColorTextField.value)
        })
        byodAppBackgroundColorColorField.addEventListener("change", function(e) {
            updateColorValue("byodAppBackgroundColor", byodAppBackgroundColorColorField.value)
        })
    }

    // UI color
    if (byodAppUiColorTextField !== null && byodAppUiColorColorField !== null &&
        colorPreviewUi !== null && noValidColorMessageUi !== null) {
        // show/hide invalid color warning on page load
        if (isColor(byodAppUiColorTextField.value)) {
            noValidColorMessageUi.classList.add('hidden')
            // show/hide color warnings on page load
            updateAllColorWarnings('byodAppUiColor', byodAppBackgroundColorTextField)
        } else {
            noValidColorMessageUi.classList.remove('hidden')
        }

        // change listener for background color: show/hide invalid color warning, show preview color
        byodAppUiColorTextField.addEventListener("change", function(e) {
            if(isColor(this.value)) {
                colorPreviewUi.style.fill = this.value // show preview color
                noValidColorMessageUi.classList.add('hidden')
                updateAllColorWarnings('byodAppUiColor', byodAppBackgroundColorTextField)
            } else {
                colorPreviewUi.style.fill = null
                noValidColorMessageUi.classList.remove('hidden')
            }

            updateColorValue("byodAppUiColor", byodAppUiColorTextField.value)
        })
        byodAppUiColorColorField.addEventListener("change", function(e) {
            updateColorValue("byodAppUiColor", byodAppUiColorColorField.value)
        })
    }

    // Background color
    if (byodWelcomeScreenBackgroundColorTextField !== null && byodWelcomeScreenBackgroundColorColorField !== null &&
        byodWelcomeScreenBackgroundColorPreview !== null && noValidColorMessageWelcomeScreenBackground !== null) {

        // show/hide invalid color warning on page load
        if (isColor(byodWelcomeScreenBackgroundColorTextField.value)) {
            noValidColorMessageWelcomeScreenBackground.classList.add('hidden')
        } else {
            noValidColorMessageWelcomeScreenBackground.classList.remove('hidden')
        }
        if (byodWelcomeScreenBackgroundImg === null){
            updateAllColorWarnings("byodWelcomeScreenBackgroundColor", null)
        }

        // change listener for background color: show/hide invalid color warning, show preview color
        byodWelcomeScreenBackgroundColorTextField.addEventListener("change", function(e) {
            if(isColor(this.value)) {
                byodWelcomeScreenBackgroundColorPreview.style.fill = this.value // shoe preview color
                noValidColorMessageWelcomeScreenBackground.classList.add('hidden')
                updateAllColorWarnings("byodWelcomeScreenBackgroundColor", null)
            } else {
                byodWelcomeScreenBackgroundColorPreview.style.fill = null
                noValidColorMessageWelcomeScreenBackground.classList.remove('hidden')
            }

            updateColorValue("byodWelcomeScreenBackgroundColor", byodWelcomeScreenBackgroundColorTextField.value)
        })
        byodWelcomeScreenBackgroundColorColorField.addEventListener("change", function(e) {
            updateColorValue("byodWelcomeScreenBackgroundColor", byodWelcomeScreenBackgroundColorColorField.value)
        })
    }

    // UI color
    if (byodWelcomeScreenUiColorTextField !== null && byodWelcomeScreenUiColorColorField !== null &&
        byodWelcomeScreenUiColorPreview !== null && noValidColorMessageWelcomeScreenUi !== null) {
        // show/hide invalid color warning on page load
        if (isColor(byodWelcomeScreenUiColorTextField.value)) {
            noValidColorMessageWelcomeScreenUi.classList.add('hidden')
            // show/hide color warnings on page load
            updateAllColorWarnings('byodWelcomeScreenUiColor', byodWelcomeScreenBackgroundColorTextField)
        } else {
            noValidColorMessageWelcomeScreenUi.classList.remove('hidden')
        }

        // change listener for background color: show/hide invalid color warning, show preview color
        byodWelcomeScreenUiColorTextField.addEventListener("change", function(e) {
            if(isColor(this.value)) {
                byodWelcomeScreenUiColorPreview.style.fill = this.value // show preview color
                noValidColorMessageWelcomeScreenUi.classList.add('hidden')
                updateAllColorWarnings('byodWelcomeScreenUiColor', byodWelcomeScreenBackgroundColorTextField)
            } else {
                byodWelcomeScreenUiColorPreview.style.fill = null
                noValidColorMessageWelcomeScreenUi.classList.remove('hidden')
            }

            updateColorValue("byodWelcomeScreenUiColor", byodWelcomeScreenUiColorTextField.value)
        })
        byodWelcomeScreenUiColorColorField.addEventListener("change", function(e) {
            updateColorValue("byodWelcomeScreenUiColor", byodWelcomeScreenUiColorColorField.value)
        })
    }

    // check if the value is a valid hex color
    function isColor(color){
        return /^#[0-9A-F]{6}$/i.test(color);
    }

    function updateColorValue(fieldId, colorValue){
        const textField = document.getElementById(fieldId + 'TextField')
        // Only trigger changeEvent if the color changed
        if (textField !== null && textField.value !== colorValue){
            textField.value = colorValue
            //trigger changeEvent
            const e = new Event("change")
            textField.dispatchEvent(e);
        }

        const colorField = document.getElementById(fieldId + 'ColorField')
        if (colorField !== null) {
            colorField.value = colorValue
        }
    }
})